import { EMPTY_CHIP_COLOR } from '..';
import { createUseTextLocalizer } from '../../../../locale/createUseTextLocalizer';
import { basicColors } from '../BasicColorPallete';
import { useHexBidiFormatter } from './useHexBidiFormatter';
import bundle from '../../NovaComponents-ColorPicker-gui-icu.properties';
const useTextLocalizer = createUseTextLocalizer(bundle);
export const useColorChipA11yInfo = props => {
  const hexBidiFormatter = useHexBidiFormatter();
  const localize = useTextLocalizer();
  const isStandardColor = basicColors.includes(props.color);
  const colorTitle = !isStandardColor ? hexBidiFormatter(props.color, {
    forceLtrDir: props.type === 'custom'
  }) : `${localize(`color.${props.color.slice(1)}.title`)} (${hexBidiFormatter(props.color)})`;
  const title = props.color !== EMPTY_CHIP_COLOR ? props.type === 'nocolor' ? undefined : props.type === 'automatic' ? localize(`automatic.title`, {
    color: colorTitle
  }) : colorTitle : undefined;
  const colorAria = !isStandardColor ? props.color.split('').join(' ') : `${localize(`color.${props.color.slice(1)}.aria`)} (${props.color.split('').join(' ')})`;
  const ariaLabel = props.color !== EMPTY_CHIP_COLOR ? props.type === 'nocolor' ? localize(`color.noColor.aria`) : props.type === 'automatic' ? localize(`automatic.aria`, {
    color: colorAria
  }) : colorAria : undefined;
  const ariaHidden = props.color === EMPTY_CHIP_COLOR ? true : undefined;
  return {
    title,
    ariaLabel,
    ariaHidden
  };
};
//# sourceMappingURL=useColorChipA11yInfo.js.map